import { useState, useEffect } from "react";
import { Plus, Trash2, ExternalLink, Link as LinkIcon, AlertTriangle } from "lucide-react";
import "./Links.css";

export default function Links() {
    const [links, setLinks] = useState(() => {
        const saved = localStorage.getItem("myWorkspaceLinks");
        if (!saved) return [];
        try {
            const parsed = JSON.parse(saved);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    });

    const [name, setName] = useState("");
    const [url, setUrl] = useState("");
    const [error, setError] = useState("");
    const [itemToDelete, setItemToDelete] = useState(null);

    useEffect(() => {
        localStorage.setItem("myWorkspaceLinks", JSON.stringify(links));
    }, [links]);

    const handleAddLink = (e) => {
        e.preventDefault();
        setError("");

        const cleanName = name.trim();
        const cleanUrl = url.trim();

        if (!cleanName || !cleanUrl) {
            setError("Preencha nome e URL para adicionar.");
            return;
        }

        let formattedUrl = cleanUrl;
        if (!/^https?:\/\//i.test(cleanUrl)) {
            formattedUrl = `https://${cleanUrl}`;
        }

        // Valida se é uma URL plausível
        try {
            new URL(formattedUrl);
        } catch {
            setError("URL inválida. Verifique o endereço digitado.");
            return;
        }

        const newLink = { id: Date.now(), name: cleanName, url: formattedUrl };

        // Insere já ordenado alfabeticamente (case-insensitive, pt-BR)
        const newList = [newLink, ...links].sort((a, b) =>
            a.name.localeCompare(b.name, "pt-BR", { sensitivity: "base" })
        );

        setLinks(newList);
        setName("");
        setUrl("");
    };

    const confirmDelete = () => {
        if (itemToDelete) {
            setLinks(links.filter((l) => l.id !== itemToDelete));
            setItemToDelete(null);
        }
    };

    return (
        <div className="links-container">
            <header className="links-header">
                <div>
                    <h1>Meus Links</h1>
                    <p>Gerencie seus acessos rápidos e referências importantes.</p>
                </div>
            </header>

            {/* FORMULÁRIO DE ADIÇÃO */}
            <form className="links-form" onSubmit={handleAddLink}>
                <div className="input-row">
                    <input
                        type="text"
                        placeholder="Nome do site (ex: Figma, GitHub)"
                        value={name}
                        onChange={(e) => { setName(e.target.value); setError(""); }}
                        className="input-name"
                    />
                    <input
                        type="text"
                        placeholder="URL (ex: github.com)"
                        value={url}
                        onChange={(e) => { setUrl(e.target.value); setError(""); }}
                        className="input-url"
                    />
                    <button type="submit" className="btn-add-link">
                        <Plus size={20} /> Adicionar
                    </button>
                </div>

                {error && <div className="links-error-msg">{error}</div>}
            </form>

            {/* LISTA DE LINKS */}
            <div className="links-grid">
                {links.length === 0 && (
                    <p className="empty-msg">Nenhum link salvo ainda.</p>
                )}

                {links.map((link) => (
                    <div key={link.id} className="link-card">
                        <div className="link-icon-box">
                            <LinkIcon size={20} />
                        </div>

                        <div className="link-content">
                            <h3>{link.name}</h3>
                            <a href={link.url} target="_blank" rel="noopener noreferrer">
                                {link.url}
                            </a>
                        </div>

                        <div className="link-actions">
                            <a
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="links-btn-icon btn-visit"
                                title="Visitar site"
                            >
                                <ExternalLink size={18} />
                            </a>
                            <button
                                onClick={() => setItemToDelete(link.id)}
                                className="links-btn-icon btn-delete"
                                title="Excluir link"
                            >
                                <Trash2 size={18} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {/* MODAL DE DELETE (classes escopadas) */}
            {itemToDelete && (
                <div className="links-modal-overlay" onClick={() => setItemToDelete(null)}>
                    <div className="links-modal-box" onClick={(e) => e.stopPropagation()}>
                        <div className="links-modal-icon">
                            <AlertTriangle size={48} />
                        </div>
                        <h3>Excluir Link?</h3>
                        <p>Deseja remover este link da sua lista?</p>
                        <div className="links-modal-actions">
                            <button
                                className="links-btn-cancel"
                                onClick={() => setItemToDelete(null)}
                            >
                                Cancelar
                            </button>
                            <button className="links-btn-confirm" onClick={confirmDelete}>
                                Sim, Excluir
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}